import { InventoryAuthority } from '@qkindex/contracts';
import {
  bulkOperationService,
  BulkItemUpdates,
} from '../services/bulkOperationService';

export interface ItemRepository {
  update(
    authority: InventoryAuthority,
    itemId: string,
    updates: BulkItemUpdates,
  ): Promise<void>;
  clearImage(authority: InventoryAuthority, itemId: string): Promise<void>;
}

/** Existing-item writes share coordination, idempotency and server location validation. */
export const firebaseItemRepository: ItemRepository = {
  async update(authority, itemId, updates) {
    const { expectedRevision, ...fields } = updates;
    await bulkOperationService.updateItems(authority, [
      {
        id: itemId,
        updates: fields,
        ...(expectedRevision === undefined
          ? {}
          : { expectedRevision: Number(expectedRevision) }),
      },
    ]);
  },
  async clearImage(authority, itemId) {
    await bulkOperationService.updateItems(authority, [
      { id: itemId, updates: { image: '', storagePath: '' } },
    ]);
  },
};
